import { AuthForm } from "@/components/auth/auth-form";
import { MoonStar } from "lucide-react";

export default function LoginPage() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center gap-4 text-center mb-8">
            <MoonStar className="h-10 w-10 text-primary" />
            <h1 className="text-4xl font-bold text-foreground">
              Welcome back to LullabAI
            </h1>
            <p className="text-muted-foreground">
              Sign in to continue tracking your child&apos;s sleep.
            </p>
        </div>
        <AuthForm mode="login" />
      </div>
    </div>
  );
}
